export default __webpack_public_path__ + "static/media/404-BG.a78a9e15.png";